import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { UserContext } from 'app/core/store/session/user-context/user-context.interface';
import { appSettings } from 'app/appSettings';
import { Florder } from 'app/core/interfaces/florder.interface';
import { FlordersFilter } from 'app/core/interfaces/florders-filter.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { util } from 'app/core/util/util';
import { ScrollService } from 'app/core/services/scroll.service';

@Component({
  selector: 'app-relocation-list',
  templateUrl: './relocation-list.component.html',
  styleUrls: ['../../florders/florder-list/florder-list.scss', './relocation-list.component.scss'],
})
export class RelocationListComponent implements OnInit, OnChanges {
  private initialized: boolean = false;

  dateFormat: string = appSettings.DATE_FORMAT_ANGULAR;
  showAll: boolean = false;

  @Input() relocations: Florder[];
  @Input() readonly definitions: Definitions;
  @Input() isLoading: boolean;
  @Input() filter: FlordersFilter;
  @Input() totalItems: number;
  @Input() authorization: AuthorizationMatrix;
  @Input() userContext: UserContext;

  @Output() openRelocation: EventEmitter<Florder> = new EventEmitter();
  @Output() pageChange: EventEmitter<number> = new EventEmitter();
  @Output() sortChange: EventEmitter<{ sortField: string; sortAscending: boolean }> = new EventEmitter();
  @Output() copyRelocation: EventEmitter<Florder> = new EventEmitter();
  @Output() asTemplate: EventEmitter<Florder> = new EventEmitter();
  @Output() itemsPerPageChange = new EventEmitter<number>();

  constructor(private scrollService: ScrollService) {}

  ngOnInit(): void {
    this.initialized = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.relocations) {
      this.scrollService.scrollToElement('relocations-list');
    }
  }

  onPageChange(pageNr) {
    this.pageChange.emit(pageNr);
  }

  sort(field: string) {
    util.sortHelper(this, field);
  }

  sortBnd = this.sort.bind(this);

  preventRouting(event) {
    event.stopPropagation();
  }

  openMenu(event) {
    event.stopPropagation();
  }
}
